import {
  getCommonInitialState,
  getCommonStart,
  getCommonSuccess,
  getCommonFailure,
} from "../utils";
import {
  GET_CHECKOUT_ORDER_FAILURE,
  GET_CHECKOUT_ORDER_START,
  GET_CHECKOUT_ORDER_SUCCESS,
  CREATE_CHECKOUT_ORDER_FAILURE,
  CREATE_CHECKOUT_ORDER_START,
  CREATE_CHECKOUT_ORDER_SUCCESS,
} from "../actions/ActionConstant";

const initialState = {
  getCheckoutOrder: getCommonInitialState(),
  createCheckoutOrder: getCommonInitialState(),
};

const CheckoutReducer = (state = initialState, action) => {

  switch (action.type) {
    case GET_CHECKOUT_ORDER_START:
      return { ...state, getCheckoutOrder: getCommonStart() };
    case GET_CHECKOUT_ORDER_SUCCESS:
      return { ...state, getCheckoutOrder: getCommonSuccess(action.data) };
    case GET_CHECKOUT_ORDER_FAILURE:
      return { ...state, getCheckoutOrder: getCommonFailure(action.error) };

    case CREATE_CHECKOUT_ORDER_START:
      return { ...state, createCheckoutOrder: getCommonStart() };
    case CREATE_CHECKOUT_ORDER_SUCCESS:
      return { ...state, createCheckoutOrder: getCommonSuccess(action.data) };
    case CREATE_CHECKOUT_ORDER_FAILURE:
      return { ...state, createCheckoutOrder: getCommonFailure(action.error) };

    default:
      return state;
  }
};

export default CheckoutReducer;
